import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../translations';
// „adres e-” / „mail.” na wąskim ekranie: łącznik w słowie zamieniany na niełamiący.
import { bezLamaniaNaLaczniku } from '../utils/lacznik';

// P3.3-A: PUBLICZNA strona po płatności z linku w mailu / widgetu (klient nie ma konta).
// Celowo statyczna — zero wywołań API (nic do wycieku); status i tak potwierdza webhook,
// a wypożyczalnia widzi opłaconą płatność u siebie.
// Parametr ?return= (doklejany przez widget) pokazuje ŚWIADOMY przycisk powrotu na stronę
// wypożyczalni — bez auto-przekierowania, więc nie działa jako open redirect.
//
// Strona jest widoczna dla ANONIMOWEGO klienta, nie dla zalogowanego pracownika — `useTranslation`
// i tak dziala (ten sam Provider globalny), ale jezyk bierze sie z `localStorage` PRZEGLADARKI,
// nie z konta klienta (klient go nie ma). Domyslnie 'pl', czyli zachowanie identyczne z tym,
// co strona miala PRZED tokenizacja (byla na sztywno po polsku).

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  padding: var(--sp-5);
`;
const Card = styled.div`
  background: var(--card-bg);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-lg);
  padding: var(--sp-8) 36px;
  max-width: 460px;
  text-align: center;
`;
const Mark = styled.div`
  width: 56px;
  height: 56px;
  margin: 0 auto var(--sp-4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => (p.$muted ? 'var(--panel-bg)' : 'var(--success-bg)')};
  color: ${p => (p.$muted ? 'var(--text-muted)' : 'var(--success)')};
`;
const H = styled.h1`font-size: var(--fs-xl); margin: 0 0 var(--sp-3); color: var(--text);`;
const P = styled.p`color: var(--text-muted); margin: 0 0 var(--sp-2); line-height: 1.6; font-size: var(--fs-base);`;
const BackLink = styled.a`
  display: inline-block;
  margin-top: var(--sp-4);
  padding: var(--sp-3) 26px;
  border-radius: var(--r-sm);
  background: var(--primary);
  color: var(--primary-contrast);
  font-weight: 600;
  font-size: var(--fs-base);
  text-decoration: none;
`;

const CheckIcon = ({ muted }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    {muted ? <path d="M9 14l-4-4 4-4M5 10h11a4 4 0 0 1 0 8h-1" /> : <path d="M20 6L9 17l-5-5" />}
  </svg>
);

function PaymentThankYou() {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const cancelled = params.get('cancelled');
  const already = params.get('already');
  const deposit = params.get('deposit');
  const ret = params.get('return') || '';
  const returnUrl = /^https?:\/\//i.test(ret) ? ret : '';
  const back = returnUrl && <BackLink href={returnUrl}>{t('paymentThankYou.backToShop')}</BackLink>;

  if (cancelled) {
    return (
      <Wrap><Card>
        <Mark $muted><CheckIcon muted /></Mark>
        <H>{t('paymentThankYou.cancelledTitle')}</H>
        <P>{bezLamaniaNaLaczniku(t('paymentThankYou.cancelledDesc'))}</P>
        {back}
      </Card></Wrap>
    );
  }

  // P3.8: kaucja to BLOKADA na karcie, nie pobranie — inna komunikacja niż przy wpłacie.
  if (deposit) {
    return (
      <Wrap><Card>
        <Mark><CheckIcon /></Mark>
        <H>{already ? t('paymentThankYou.depositAlreadyTitle') : t('paymentThankYou.depositTitle')}</H>
        <P>{bezLamaniaNaLaczniku(t('paymentThankYou.depositDesc1'))}</P>
        <P>{bezLamaniaNaLaczniku(t('paymentThankYou.contactHint'))}</P>
        {back}
      </Card></Wrap>
    );
  }

  return (
    <Wrap><Card>
      <Mark><CheckIcon /></Mark>
      <H>{already ? t('paymentThankYou.alreadyPaidTitle') : t('paymentThankYou.thankYouTitle')}</H>
      <P>{bezLamaniaNaLaczniku(already ? t('paymentThankYou.alreadyPaidDesc') : t('paymentThankYou.paidDesc'))}</P>
      <P>{bezLamaniaNaLaczniku(t('paymentThankYou.shopSeesPayment'))}</P>
      {back}
    </Card></Wrap>
  );
}

export default PaymentThankYou;
